import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'NumberFilter',
  standalone: false,
})
/**
 * Usage:
 * valid params lte, lt, eq, gt, gte
 *
 * NumberFilter: 'field': type : value
 *
 * value = a date object.
 *
 * ts file:
 *
 * var searchDate = new Date();
 *
 * <tr *ngFor="let item of mf.data | NumberFilter:'Count':'lte':customNumber:showNull">
 */
export class NumberFilter implements PipeTransform {
  transform(
    values: Array<Record<string, unknown>>,
    key: string,
    type: string,
    args: number | null | undefined,
    showNull: boolean
  ): Array<Record<string, unknown>> {
    return values.filter((value) => {
      if (args == undefined) {
        return true;
      }

      if (args || args == 0) {
        if (value && value.hasOwnProperty(key)) {
          const currentValue = value[key];
          //if there is a null or undefined value dont show it
          if (!currentValue && currentValue != 0 && showNull == false)
            return false;
          else if (showNull == true && !currentValue && currentValue != 0) {
            return true;
          } else if (
            typeof currentValue == 'number' &&
            typeof args == 'number'
          ) {
            const number = currentValue;

            if (type == 'lt') {
              if (number < args) return true;
              else return false;
            } else if (type == 'lte') {
              if (number <= args) return true;
              else return false;
            } else if (type == 'gt') {
              if (number > args) return true;
              else return false;
            } else if (type == 'gte') {
              if (number >= args) return true;
              else return false;
            } else if (type == 'eq') {
              if (number == args) return true;
              else return false;
            }
          }
        }
      }

      return true;
    });
  }
}
